/**
 * Module to encrypt data using RSA public key
 * JS Encrypt lib is fetched from CDN, check file  'scripts.js-encrypt.liquid'
 *
 */

import * as DataDogLogs from '~/lib/datadog/datadog';

const EMAIL_PUBLIC_RSA_KEY = `-----BEGIN PUBLIC KEY-----
MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDL0bn59V0XP6gfLZSudymp1o3L
5t5tNNJNgzzSmuqYjVV48FK2ofQsSp3idXB+djySq51UABozutwIRQiiltaP/X3u
TjJEuuYGn2L7nGRnn/HPWAa+OScm4FkNLgqKGfPNz+6vSW8Ab0XYZBNLLsTy+ulP
jnn6iRdveAo2LRZ64wIDAQAB
-----END PUBLIC KEY-----`;

/**
 * Encrypts text data using RSA public key
 *
 * @param {string} textToEncrypt
 * @returns {string} encrypted text
 */
const encryptTextData = (textToEncrypt) => {
  try {
    const encrytper = new window.JSEncrypt();
    encrytper.setPublicKey(EMAIL_PUBLIC_RSA_KEY);
    const encryptedText = encrytper.encrypt(textToEncrypt);

    return encryptedText;
  } catch (error) {
    DataDogLogs.error('[Allbirds utils] - encryptTextData - Error encypting text', {}, error);
  }
};

export { encryptTextData };
